import styled from 'styled-components';

const CommentDateText = styled.div`
  margin-left: 16px;
  color: rgba(0, 0, 0, 0.35);
`;

export default CommentDateText;
